export const USER_LOGGINED_IN_KEY_PREFIX = 'wordpress_logged_in_';

export const SESSION_KEY_PREFIX = 'wp_woocommerce_session_';
export const CART_ITEM_KEY = 'woocommerce_items_in_cart';

export const CURRENCY_KEY = 'aelia_cs_selected_currency';
export const COUNTRY_KEY = 'bft_selected_country';

export const WISHLIST_GUEST_USER_COOKIE_KEY = 'ss_wishlist_customer_key';
export const WISHLIST_DATA_COOKIE_KEY = 'ss_wishlist_data';

export const RECENTLY_VIEWED_PRODUCTS_KEY = 'woocommerce_recently_viewed';
